export default __webpack_public_path__ + "static/media/bkg--agent.0719c0d8.jpg";